/**
 * Which of this app's API calls dwlf-retail-api serves: the account-free engine reads in its
 * allowlist (dwlf-retail-api `src/gateway/engineRoutes.ts`, which owns the list). A path listed here
 * and not there is a 404 from retail-api, so a route is added there first. A path not listed here
 * keeps going to SPT with the SPT session, which includes the reads that mix the person's own rows
 * into global data (`events`, `events/unified`, `intelligence/:symbol`, `markets/overview`): under
 * retail-api's shared key they would answer as its service account, so they wait for DWLF-399.
 */
const SYMBOL = ':symbol';
const ENGINE_PATHS = [
  'symbols',
  'symbols/sectors',
  'symbols/sectors/info',
  // Explicit, though `symbols/:symbol` also matches: SPT serves it ahead of the per-symbol route (DWLF-509).
  'symbols/groups',
  `symbols/${SYMBOL}`,
  'market-data/symbols',
  `market-data/${SYMBOL}`,
  'quotes',
  'cycles/windows',
  'cycles/state',
  `chart-indicators/${SYMBOL}`,
  `chart-indicators/${SYMBOL}/types`,
  `support-resistance/${SYMBOL}`,
  `trendlines/${SYMBOL}`,
  `trendlines/weekly/${SYMBOL}`,
  `swings/${SYMBOL}`,
  `swings/weekly/${SYMBOL}`,
  `fib-levels/system/${SYMBOL}`,
  'ranges',
  `ranges/${SYMBOL}`,
  `regime/${SYMBOL}`,
  'stages',
  `stages/${SYMBOL}`,
  'correlations/active',
  'markets/cot',
  'macro-weather',
  'cohort-breadth',
  'economic-calendar',
];

/** retail-api's symbol segment: what it would refuse stays on SPT rather than failing there. */
const SYMBOL_SEGMENT = '(?!\\.)(?![^/]*\\.\\.)(?![^/]*(?:\\.%2[Ff]|%2[Ff]\\.))(?:[A-Za-z0-9._-]|%2[Ff]){1,32}';

const PATTERNS = ENGINE_PATHS.map((path) => new RegExp(
  `^${path.split('/').map((s) => (s === SYMBOL ? SYMBOL_SEGMENT : s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))).join('/')}$`,
));

/**
 * The retail-api path for an axios request URL (`/market-data/AAPL?interval=1d` →
 * `/engine/market-data/AAPL?interval=1d`), or null when retail-api does not serve it. Only a
 * relative URL can route there: an absolute one names its own host.
 */
export function engineProxyUrl(url) {
  if (typeof url !== 'string' || /^[a-z][a-z0-9+.-]*:/i.test(url) || url.startsWith('//')) {
    return null;
  }
  const queryAt = url.search(/[?#]/);
  const pathPart = queryAt === -1 ? url : url.slice(0, queryAt);
  const query = queryAt === -1 ? '' : url.slice(queryAt);
  const path = pathPart.replace(/^\/+/, '').replace(/\/+$/, '');
  return PATTERNS.some((p) => p.test(path)) ? `/engine/${path}${query}` : null;
}
